module.exports = __webpack_public_path__ + "img/text_saijai.5e6aec9f.png";